<template>
  <base-data-table
    :items="municipalityCooperations"
    title="自治体連携"
    header-icon="mdi-sitemap"
    :column-widths="['170px', '170px', '110px', '170px', '140px', '', '120px']"
  >
    <template #header-actions>
      <v-btn
        color="#3ACAC9"
        variant="flat"
        size="small"
        prepend-icon="mdi-plus"
        class="text-white"
        @click="$emit('add-cooperation')"
      >
        新規登録
      </v-btn>
    </template>
    <template #header-cells>
      <th>同意メール送信日時</th>
      <th>返信日時</th>
      <th>同意の有無</th>
      <th>連携実施日時</th>
      <th>自治体名</th>
      <th>対応補足</th>
      <th />
    </template>
    <template #cells="{ row: cooperation }">
      <td>{{ cooperation.consentMailSentAt }}</td>
      <td>{{ cooperation.repliedAt }}</td>
      <td>{{ cooperation.replyContentLabel }}</td>
      <td>{{ cooperation.cooperatedAt }}</td>
      <td>{{ cooperation.municipalityName }}</td>
      <td>
        <div class="base-data-table-two-line-clamp">{{ cooperation.note }}</div>
      </td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          @click="$emit('open-detail', cooperation)"
        >
          詳細を開く
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";

export default {
  name: "FaceSheetMunicipalityCooperationTable",
  components: {
    BaseDataTable
  },
  props: {
    municipalityCooperations: {
      type: Array,
      default: () => []
    }
  },
  emits: ["add-cooperation", "open-detail"]
};
</script>
